import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_ADMIN_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
});

const initOptions = {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
    flow: 'standard'
};

const initKeycloak = keycloak.init(initOptions);

export { keycloak, initKeycloak };